export class FetchFeatureFlags {
  static readonly type = '[FeatureFlags] Fetch Feature Flags';
  /**
   * @param userId identity the fetched flags belong to, cached alongside them
   *   so a different user logging in on the same browser cannot inherit them.
   */
  constructor(public readonly userId: string) {}
}
